// @flow
import React, { Fragment, Component } from 'react';
import cx from 'classnames';
import throttle from 'lodash/throttle';
import queryString from 'query-string';
import { type ContextRouter, withRouter } from 'react-router-dom';
import { MdSearch } from 'react-icons/md';
import axios from 'lib/defaultClient';
import { SearchActions } from 'store/actionCreators';
import SearchAutoComplete from '../../search/SearchAutoComplete';
import './MainSearchBox.scss';

type Props = {
  onSearch: (keyword: string) => void,
  currentMenu: string,
} & ContextRouter;

type State = {
  value: string,
  focus: boolean,
  autoComplete: boolean,
};

class MainSearchBox extends Component<Props, State> {
  input = React.createRef();
  state = {
    value: queryString.parse(this.props.location.search).q || '',
    focus: false,
    pointer: true,
    autoComplete: false,
  };

  resetState = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      value: '',
      focus: false,
      autoComplete: false,
    });
  };

  onIconClick = () => {
    const input = this.input.current;
    if (!input) return;
    if (this.state.value === '') {
      input.focus();
    }
  };

  onPointer = pointer => {
    this.setState({
      pointer,
    });
  };

  onFocus = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      focus: true,
      pointer: true,
    });
  };

  onBlur = (e: SyntheticInputEvent<HTMLInputElement>) => {
    // eslint-disable-next-line prefer-destructuring
    const currentTarget = e.currentTarget;
    // Check the newly focused element in the next tick of the event loop
    setTimeout(() => {
      // Check if the new activeElement is a child of the original container
      if (!currentTarget.contains(document.activeElement)) {
        // You can invoke a callback or add custom logic here
        this.setState({
          focus: false,
        });
      }
    }, 0);
  };

  throttledSearch = throttle(query => {
    SearchActions.publicAutoCompleteSearch({ q: query });
  }, 500);

  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (newValue) {
      this.throttledSearch(newValue);
      this.setState({
        value: newValue,
        pointer: true,
        focus: true,
        autoComplete: true,
      });
    } else {
      this.setState({
        value: '',
        pointer: true,
        focus: false,
        autoComplete: false,
      });
    }
  };

  onKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && this.state.value !== '' && this.state.pointer) {
      // storage.unshift('searchHistory', this.state.value);
      // SearchActions.insertSearchHistory(this.state.value);
      this.props.onSearch(this.state.value);
      this.setState({
        focus: false,
      });
    }
  };

  goProduct = async (id, part_number) => {
    try {
      const result = await axios.get(`/products/url/${id}`);
      this.resetState();
      this.props.history.push(`${result.data}?part_number=${part_number}`);
    } catch (e) {
      this.props.history.push(`/404`);
    }
  };

  handleMouseClick = () => {
    this.setState({
      pointer: true,
    });
  };

  isIE = () => {
    const ua = navigator.userAgent;
    return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
  };

  componentDidMount() {
    const searchIconElement = document.getElementsByClassName('search-icon')[0];
    if (!this.isIE() && searchIconElement) {
      searchIconElement.classList.add('rotate');
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State, prevContext: *): * {
    const { q: q1 } = queryString.parse(this.props.location.search);
    const { q: q2 } = queryString.parse(prevProps.location.search);
    if (q1 !== q2) {
      this.setState({
        value: q1 || '',
      });
    }
  }

  render() {
    return (
      <div
        className={cx('MainSearchBox', { focus: this.state.focus })}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onClick={this.handleMouseClick}
      >
        <div className="gray-rect">
          <MdSearch onClick={this.onIconClick} className={`search-icon`} />
          <input
            type="search"
            value={this.state.value}
            ref={this.input}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
            placeholder="카탈로그 번호, CAS 번호, 제품명, 브랜드명으로 검색해보세요!"
          />
        </div>
        <Fragment>
          {this.state.autoComplete && this.state.focus && (
            <div className="gray-rect1">
              <div className="search-list">
                <SearchAutoComplete
                  resetState={this.resetState}
                  goProduct={this.goProduct}
                  onPointer={this.onPointer}
                  history={this.props.history}
                />
              </div>
            </div>
          )}
        </Fragment>
      </div>
    );
  }
}

export default withRouter(MainSearchBox);



// WEBPACK FOOTER //
// ./src/components/main/MainSearchBox/MainSearchBox.js